import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function IpoReadiness() {
	return (
		<>
			<div className="beratung_cont" id="readiness">
				<HelmetProvider>
					<Helmet>
						<title>Beratung bei IPO-Readiness</title>
						<meta name="description" content="Beratung bei IPO-Readiness" />
						<meta
							name="keywords"
							content="Finanzierung ,Digitalisierungsberatung, Prozessberatung, Börsengänge, IPO, Feingeist, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<h1>Beratung bei IPO-Readiness</h1>
				<h2>Wir machen Sie für das Parkett fit</h2>
				<p>
					Initial public offering: Die Börsenersteinführung oder auch das
					Börsendebüt genannt. Die Finanzierung des Unternehmens über den
					Kapitalmarkt bringt große Herausforderungen mit sich. Dies gilt
					insbesondere – aber nicht ausschließlich – für den klassischen
					Börsengang (IPO) oder die Emission von Anleihen. Damit einhergehende
					oder vorher durchgeführte Kapitalerhöhungen mit und ohne Bezugsrecht
					erfordern ebenfalls Erfahrungen und ein eingespieltes Team.
				</p>
				<h2>
					Empfehlenswert ist der frühzeitige Fokus auf die Klärung folgender
					Fragen:
				</h2>
				<ul className="typeset-u-list">
					<li>
						Aktueller Stand des Unternehmens in Bezug auf die hohen
						Anforderungen (Gap-Analyse)
					</li>
					<li>
						Welche Aufgaben (Pflicht und Kür) sind bis zum Termin der
						Kapitalmaßnahme noch durchzuführen (z.B. für den Börsengang)?
					</li>
					<li>
						Exakte inhaltliche und zeitliche Planung im Sinne eines
						Projektmanagements sowie genaue Steuerung/Überwachung des
						Projektfortschritts.
					</li>
				</ul>
				<p>
					Gern unterstützen wir Sie bei Ihrer Unternehmensfinanzierung von der
					ersten Stunde der Alternativenabwägung bis zur durchgeführten
					Maßnahme.
				</p>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
